import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select, FormControl, MuiThemeProvider } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
  createTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';
import BootstrapInput from './BootstrapInput';

const MaterialSelect = ({ options, handleChange, selectedValue }) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: '100%',
      height: 33,
      backgroundColor: '#fff',
      borderRadius: 3,
      border: '1px solid #dee2e6',
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
    },

    FormHelperText: {
      paddingLeft: 17,
    },

    Select: {
      maxWidth: '100%',
      fontSize: 13,
      color: '#30313f',
      height: '2rem',
    },
  }));

  const theme = createTheme({
    overrides: {
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  });

  const classes = useStyles();

  const menuItems = options.map((item) => (
    <MenuItem
      className={classes.Select}
      key={item.value}
      value={item.value}
      name={item.label}
    >
      {item.label}
    </MenuItem>
  ));

  const findSelectedOption = (value) => {
    return options.find((cl) => cl.id === value);
  };

  const changeSelected = (id) => {
    handleChange(findSelectedOption(id));
  };

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              displayEmpty
              input={<BootstrapInput />}
              className={classes.Select}
              defaultValue=""
              value={selectedValue && selectedValue.value}
              onChange={(event) => changeSelected(event.target.value)}
            >
              {menuItems}
            </Select>
          </FormControl>
        </div>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

MaterialSelect.propTypes = {
  selectedValue: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
};

MaterialSelect.defaultProps = {
  selectedValue: undefined,
};

export default withTranslation('common')(memo(MaterialSelect));
